import Header from './Headers';

import Config from '../config/config';
import Const from '../util/Constants';

class SourceAPI {
  
  static list = (success, failure) => {
    fetch(Config.app.link + 'api/source', new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
  static save = (product, success, failure) => {
    fetch(Config.app.link + 'api/source', new Header('POST', product))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static delete = (id, success, failure) => {
    fetch(Config.app.link + 'api/source/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}
export default SourceAPI;